const FilterTypes = {
  START_FETCH_APPLICATION_ADMIN_LEVELS: 'START_FETCH_APPLICATION_ADMIN_LEVELS',
  FETCH_APPLICATION_ADMIN_LEVELS_SUCCESS:
    'FETCH_APPLICATION_ADMIN_LEVELS_SUCCESS',
  FETCH_APPLICATION_ADMIN_LEVELS_FAILURE:
    'FETCH_APPLICATION_ADMIN_LEVELS_FAILURE',

  START_FETCH_ADMIN_LEVELS_COURSES: 'START_FETCH_ADMIN_LEVELS_COURSES',
  FETCH_ADMIN_LEVELS_COURSES_SUCCESS:
    'FETCH_ADMIN_LEVELS_COURSES_SUCCESS',
  FETCH_ADMIN_LEVELS_COURSES_FAILURE:
    'FETCH_ADMIN_LEVELS_COURSES_FAILURE',
};

export default FilterTypes;
